import { Menu } from '../actions/menu'
import { AppState } from '../store'

export const menuSelector = (state: AppState): Menu => state?.menu ?? []
